define(['jQuery',
        'library/fcse-compatibility/object',
        'library/fcse-component/optionsMixin'],

    /**
     * @returns {GtmBase}
     */
    function ($, Object, OptionsMixin) {

        function GtmBase(options) {
            this.addOptions(options);
            this.trackPage();
        }

        GtmBase.prototype = $.extend(Object.create(OptionsMixin), /** @lends GtmBase.prototype */{
            trackData: function (data) {
                data = $.extend({
                    pageType: this.option('pageType'),
                    country: this.option('country')
                }, data);

                window.dataLayer.push(data);
            },
            trackEvent: function (data) {
                window.dataLayer.push(data);
            },
            /**
             * @abstract
             */
            trackPage: function () {}
        });

        return GtmBase;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/googletagmanager/GtmBase.js